import './style.scss';

export function payment_cards_block() {

    const block = document.querySelector('.payment_cards_block');
    if (!block) return;

}
